import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import Logo from "./Logo";
import { useAuth } from "../context/AuthContext";

const HeaderDashboard = ({ user, onMenuClick }) => {

  const { user: authUser, logout } = useAuth();
  const homePath = String(authUser?.idRol) === "2" ? "/course" : "/available-courses";

  const handleLogout = () => {
    logout();
  };

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{ bgcolor: "#b6c56b", paddingX: 2, paddingY: 1 }}
    >
      <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
        <Box display="flex" alignItems="center" gap={2}>
          {/* Botón para abrir el sidebar */}
          <IconButton color="inherit" onClick={onMenuClick}>
            <MenuIcon />
          </IconButton>

          {/* Logo */}
          <Logo display={{ xs: "none", md: "flex" }} redirectPath={homePath} />
        </Box>

        <Box display="flex" alignItems="center" gap={2}>
          <IconButton color="inherit" onClick={handleLogout}>
            <LogoutIcon />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default HeaderDashboard;
